import React from 'react';
import PropTypes from 'prop-types';
import { Form, Typography } from 'components/base';
import { formatPrice } from 'utils/format';
import useQuery from 'ecommerce/hooks/useQuery';

const QuantitySelect = props => {
  const [quantity, setQuantity] = useQuery('quantity', '1');

  if (!props.product.priceTiers) {
    return null;
  }

  return (
    <div className="configuration-row mb-2">
      <Typography.Span block className="label text-light text-left">
        QUANTITY
      </Typography.Span>
      <Form.Select onChange={e => setQuantity(e.target.value)} value={quantity}>
        {Object.keys(props.product.priceTiers).map(option => (
          <Form.SelectOption key={option} value={option}>
            {`${option}  -  ${formatPrice(
              props.product.priceTiers[option],
              props.product.currency,
            )} Per ${props.productType}`}
          </Form.SelectOption>
        ))}
      </Form.Select>
    </div>
  );
};

QuantitySelect.propTypes = {
  product: PropTypes.object,
  productType: PropTypes.string,
};

QuantitySelect.defaultProps = {
  productType: 'Print',
};

export default QuantitySelect;
